const KNOWN_SECTION_TYPES = new Set(["pageTitle", "reportsTabBar"]);

const KNOWN_WIDGET_TYPES = new Set(["reportsTab"]);

const requiredString = (value) => typeof value === "string" && value.trim().length > 0;

export function validateReportsLayout(layout) {
  const errors = [];

  if (!layout || typeof layout !== "object") {
    return { valid: false, errors: ["Layout must be an object"] };
  }

  if (typeof layout.schemaVersion !== "number") {
    errors.push("schemaVersion must be a number");
  }

  if (!requiredString(layout.pageId)) {
    errors.push("pageId is required");
  }

  if (!requiredString(layout.module)) {
    errors.push("module is required");
  }

  if (!Array.isArray(layout.sections) || layout.sections.length === 0) {
    errors.push("sections must be a non-empty array");
  } else {
    const hasTabBar = layout.sections.some((section) => section?.type === "reportsTabBar");
    if (!hasTabBar) {
      errors.push("sections must include a reportsTabBar section");
    }

    layout.sections.forEach((section, sectionIndex) => {
      if (!requiredString(section?.id)) {
        errors.push(`sections[${sectionIndex}].id is required`);
      }

      if (!requiredString(section?.type)) {
        errors.push(`sections[${sectionIndex}].type is required`);
      } else if (!KNOWN_SECTION_TYPES.has(section.type)) {
        errors.push(`sections[${sectionIndex}] has unknown type "${section.type}"`);
      }

      if (section?.type === "reportsTabBar") {
        if (!Array.isArray(section.widgets) || section.widgets.length === 0) {
          errors.push(`sections[${sectionIndex}].widgets must be a non-empty array`);
        } else {
          section.widgets.forEach((widget, widgetIndex) => {
            if (!requiredString(widget?.tabKey)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}].tabKey is required`,
              );
            }
            if (widget?.type && !KNOWN_WIDGET_TYPES.has(widget.type)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}] has unknown type "${widget.type}"`,
              );
            }
          });
        }
      }
    });
  }

  return { valid: errors.length === 0, errors };
}
